__turbopack_context__.v({
  "card-edit-section": "customize-card-module-scss-module__Gesnvq__card-edit-section",
  "card-edit-section-explainer": "customize-card-module-scss-module__Gesnvq__card-edit-section-explainer",
  "card-edit-section-header": "customize-card-module-scss-module__Gesnvq__card-edit-section-header",
  "card-edit-section-header-row": "customize-card-module-scss-module__Gesnvq__card-edit-section-header-row",
  "card-images": "customize-card-module-scss-module__Gesnvq__card-images",
  "side-section-content": "customize-card-module-scss-module__Gesnvq__side-section-content",
});
